module.exports = __webpack_public_path__ + "img/twitter.c2769c32.png";